import React from 'react';

import Router from 'components/Router/Router';
import { AuthContextProvider } from 'utils/contexts/auth-context';
import { ThemeModeProvider } from 'utils/contexts/theme-mode.context';
import { Auth0Provider } from '@auth0/auth0-react';
import { withLDProvider } from 'launchdarkly-react-client-sdk';

function App() {
  return (
    <Auth0Provider
      domain={`${process.env.REACT_APP_DOMAIN}`}
      clientId={`${process.env.REACT_APP_CLIENT_ID}`}
      redirectUri={window.location.origin}
      audience={process.env.REACT_APP_AUDIENCE}
    >
      <AuthContextProvider>
        <ThemeModeProvider>
          <Router />
        </ThemeModeProvider>
      </AuthContextProvider>
    </Auth0Provider>
  );
}

export default withLDProvider({
  clientSideID: process.env.REACT_APP_LAUNCH_DARKLY_ENV_ID || '',
  reactOptions: {
    useCamelCaseFlagKeys: false,
  },
})(App);
